import axios from 'axios';
import { AMLS_COMMON } from '../pages/constants/globalConstants';

export const apiConfig = {
  // root endpoint
  serviceApi: localStorage.getItem('service-api') || 'http://3.226.6.231:8080',
  serviceApiCM: localStorage.getItem('service-api-cm'),

  // api endpoints
  login: 'users/auth',
  logout: 'users/session',
  changepwd: 'users/changePassword'
};

export function createAxiosServiceInstance(accessToken, baseURL, timeout) {
  let headers = {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  };
  if (accessToken) {
    headers = {
      ...headers,
      Authorization: `${accessToken}`
    };
  } else {
    const saved_token =
      (localStorage && localStorage.getItem('id_token')) || '';
    const productId = (localStorage && localStorage.getItem('productId')) || '';
    headers = {
      ...headers,
      Authorization: `${saved_token}`,
      ProductId: productId
    };
  }

  const serviceAxios = axios.create({
    baseURL: baseURL || apiConfig.serviceApi,
    timeout: timeout ?? 200000,
    headers: headers,
    validateStatus: false
  });

  serviceAxios.interceptors.response.use(
    function (response) {
      if (response.status === 401) {
        if (localStorage && localStorage.getItem('id_token')) {
          window.onbeforeunload = null;
          window.localStorage.removeItem('id_token');
          window.localStorage.removeItem('productId');
          window.localStorage.removeItem('tenant-id');
          window.location = '/';
          alert(response.data.message ?? 'Session expired!');
          return;
        }
      }

      if (response.status === 504) {
        return Promise.reject(response);
      }

      return response;
    },
    function (error) {
      if (error.status === 401) {
        window.onbeforeunload = null;
        window.localStorage.removeItem('id_token');
        window.localStorage.removeItem('productId');
        window.localStorage.removeItem('tenant-id');
        window.location = '/';
      } else {
        return Promise.reject(error);
      }
    }
  );

  return serviceAxios;
}

export function createAxiosAuthInstance() {
  let headers = {
    'Content-Type': 'application/json'
  };

  const authAxios = axios.create({
    baseURL: `${apiConfig.serviceApi}${AMLS_COMMON}`,
    timeout: 180000,
    headers: headers
  });

  return authAxios;
}

export function createAxiosHeaderlessInstance() {
  let headers = {
    'Content-Type': 'application/json'
  };

  const apiBase = apiConfig.serviceApiCM || apiConfig.serviceApi;

  const authAxios = axios.create({
    baseURL: `${apiBase}${AMLS_COMMON}`,
    timeout: 180000,
    headers: headers
  });

  authAxios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      return Promise.reject(error);
    }
  );

  return authAxios;
}
